<rt-dialog-header
  [heading]="'app.requisitions.approval_request_dialog.heading' | translate"
  [subheading]="'app.requisitions.approval_request_dialog.subheading_approval_message' | translate"
>
  <span class="step">{{ 'app.requisitions.approval_request_dialog.step_2' | translate }}</span>
</rt-dialog-header>

<rt-dialog-body layout-vertical>
  <div layout-horizontal layout-align-items-center margin-bottom-small>
    <rt-heading variant="uppercased text-color">{{
      'app.requisitions.approval_request_dialog.message_heading' | translate
    }}</rt-heading>
    <rt-admins-avatars
      avatarSize="small-x"
      [admins]="approvers"
      [stacked]="true"
      [editable]="false"
      margin-left-small-x
    />
    <rt-badge color="optional" [text]="'app.common.optional' | translate" margin-left-small-x />
  </div>
  <rt-wysiwyg
    prosemirrorViewboxConfig
    [config]="ProsemirrorConfig"
    [formControl]="wysiwygControl"
    [footerTmpl]="footerTpl"
    [actionButtons]="actionButtons"
    [placeholder]="'app.requisitions.approval_request_dialog.message_placeholder' | translate"
    [withMinHeight]="true"
  />
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button [disabled]="submitting" class="optional" (click)="goBack.emit()" variant="plain">
    <rt-icon name="arrow-back" />
    {{ 'app.common.go_back' | translate }}
  </rt-button>
  <rt-button [disabled]="submitting" (click)="cancel.emit()" variant="plain">{{
    'app.common.cancel' | translate
  }}</rt-button>
  <rt-button
    [disabled]="submitting"
    [loading]="submitting"
    (click)="submitRequest()"
    variant="primary"
  >
    <rt-icon [name]="'send'" />
    {{ 'app.requisitions.actions.request_approval' | translate }}
  </rt-button>
</rt-dialog-footer>

<input #fileInput type="file" hidden (change)="uploadAttachment(fileInput.files, fileInput)" />

<ng-template #footerTpl>
  @if (attachments.length || attachmentsUploading.length) {
    <div padding-small>
      <rt-divider variant="line dark" />
      @for (attachment of attachments; track trackById($index, attachment)) {
        <rt-attachment-item
          [attachment]="attachment"
          [hasDeleteAction]="true"
          (deleteClick)="deleteAttachment($event)"
          type="list-item"
        />
      }
      @for (
        loadingAttachment of attachmentsUploading;
        track trackByIndex($index, loadingAttachment)
      ) {
        <rt-spinner variant="small" />
      }
    </div>
  }
</ng-template>
